import { NgStyle } from '@angular/common'
import { Component, Input } from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

const INDENT_MULTIPLIER = 10

@Component({
  imports: [NgStyle, ds.FormattedValue.Module],
  selector: 'atn-report-table-cell',
  styleUrls: ['./report-table-cell.component.scss'],
  templateUrl: './report-table-cell.component.html',
})
export class AtnReportTableCellComponent {
  @Input()
  public set cell(cell: ents.extra.common.Report.Cell | undefined) {
    if (!cell) {
      return
    }
    const { content, align, indents, style } = cell
    if (content) {
      this._setValue(content)
    }
    if (align) {
      this.styles.textAlign = align
    }
    if (indents) {
      this.styles.paddingLeft = `${indents * INDENT_MULTIPLIER}px`
    }
    this._setAdditionalStyles(style)
  }

  public styles: Partial<CSSStyleDeclaration> = {}
  public value: ents.core.common.value.Raw | undefined
  public type: ents.core.common.value.types.Type =
    ents.core.common.value.types.Intrinsic.Text
  public options: ds.FormattedValue.Models.Options.Numerical | undefined

  private _setValue(value: ents.core.common.value.WithInfo.Strict): void {
    const { raw, precision, type } = value
    this.type = type ?? ents.core.common.value.types.Intrinsic.Text
    // TODO: Formatted value should be fixed in design library to accommodate
    // 'ents.core.common.value.WithInfo.Strict' type.
    if (ents.core.common.value.Raw.isRaw(raw)) {
      this.value = raw
      this.options = precision
    } else {
      throw new Error(`Value of type '${type?.toString()}' is not handled.`)
    }
  }

  private _setAdditionalStyles(
    style?: ents.extra.common.Report.Cell.Style,
  ): void {
    if (!style) {
      return
    }

    switch (style) {
      // TODO: Not sure if report header should have same styling as column header
      case ents.extra.common.Report.Cell.Style.ReportHeader:
      case ents.extra.common.Report.Cell.Style.ColumnHeader:
        this.styles = {
          ...this.styles,
          fontWeight: 'bold',
        }
        break
      case ents.extra.common.Report.Cell.Style.Label:
      case ents.extra.common.Report.Cell.Style.Subtotal:
        this.styles = {
          ...this.styles,
          fontWeight: 'bold',
        }
        break
      case ents.extra.common.Report.Cell.Style.SectionHeader:
        this.styles = {
          ...this.styles,
          fontWeight: 'bold',
        }
        break
      case ents.extra.common.Report.Cell.Style.GrandTotal:
        this.styles = {
          ...this.styles,
          color: ds.color.Legacy.Main.Primary,
          fontWeight: 'bold',
        }
        break
    }
  }
}
